import React from "react";
import { Col, Row, Card } from "react-bootstrap";

const HotelStats = ({ platformData }) => {
  // Example hotelData structure
  // hotelData = {
  //   totalHotels: 50,
  //   vietnamHotels: 10,
  //   thailandHotels: 5,
  //   activeHotels: 40,
  //   inactiveHotels: 10
  // }

  const stats = [
    { label: "Total Hotels", value: platformData?.totalHotel || 0 },
    { label: "Active Hotels", value: platformData?.totalActive || 0 },
    { label: "InActive Hotels", value: platformData?.totalInactive || 0 },
    // { label: "Thailand Hotels", value: platformData?.totalThaiHotel || 0 },
    // { label: "Vietnam Hotels", value: platformData?.totalVietHotel || 0 },

    // { label: "Inactivated Th", value: platformData?.inActiveThaiHotel || 0 },
    // { label: "Inactivated VN", value: platformData?.inActiveVietHotel || 0 },
  ];

  return (
    <Row className="g-4 py-2">
      <ul className="customfiveBox p-0 mt-3 mb-0">
        {stats.map((item, idx) => (
          // <Col key={idx} lg="12" md="2" sm="6">
          <li>

            <Card
              className="text-center h-100"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "default",
                background: "#e8307a17",
                border: "0px"
              }}
            >
              <Card.Body>
                <Card.Title style={{ fontSize: "12px", fontWeight: 700, color: "#000000" }}>
                  {item.label}
                </Card.Title>
                <Card.Text
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "#E8307A",
                  }}
                >
                  {item.value}
                </Card.Text>
              </Card.Body>
            </Card>
          </li>

          // </Col>
        ))}
      </ul>

    </Row>
  );
};

export default HotelStats;
